import { Page } from '@/core/architecture'

import { SMSVerificationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * SMSVerification Page
 * Implemented as a practical sample.
 */
export const SMSVerification: Page = () => {
  const { state, actions } = useViewModel()

  return <SMSVerificationTemplate state={state} {...actions} />
}
